import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import "./underlinedButton.scss";
/*
 * Underlined Button Component
 */
const UnderlinedButton = ({ label, onClick, style, fiftyPercentWidth, extraClassName, howToUse, disabled, dataAttr }) => (_jsx("button", { onClick: onClick, type: "button", className: `underlined-form-button ${howToUse ? "howToUse_underlined-form-button" : ""} ${fiftyPercentWidth ? "fifty-percent-width_mobile_underlined-form-button" : ""} ${extraClassName} ${disabled && "underlined-form-button__disabled"}`, "data-profileclick": label, style: { ...style }, disabled: disabled, "data-attr": dataAttr || "underlined-button", children: label }));
export default UnderlinedButton;
